import { render } from "./ChatWindow.vue?vue&type=template&id=10b01756&scoped=true"
import script from "./ChatWindow.vue?vue&type=script&lang=js"
export * from "./ChatWindow.vue?vue&type=script&lang=js"

import "./ChatWindow.vue?vue&type=style&index=0&id=10b01756&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-10b01756"

export default script